import Connections from '../../connections';
import {
  action, observable,
} from 'mobx';
import {
  forgotPasswordValidateToken, ResetPasswordRequest,
} from '../../axios/requests';
import {
  IResetPasswordStore,
} from '../storeInterfaces/resetPasswordInterface';

export class ResetPassword implements IResetPasswordStore {
  @observable verified = false;

  @action
  public async handleResetValidation(token: string) {
    try {
      const data = {
        token,
      };
      const response = await Connections.wadiDeglaAxios.httpPost(forgotPasswordValidateToken, data);
      this.verified = true;
      console.log(response);
    } catch (error) {
      console.log(error);
      this.verified = false;
    }
  }

  @action
  public async handleResetPassword(newPassword: string, token: any): Promise<any> {
    try {
      const data = {
        newPassword,
        token,
      };
      const response = await Connections.wadiDeglaAxios.httpPut(ResetPasswordRequest, data);
    } catch (error) {
      console.log(error);
    }
  }
}
